/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetProviderDoctorsSuccessfulActionPayload,
  GetProviderDoctorByIdActionPayload,
  GetProviderDoctorByIdSuccessfulActionPayload,
  CreateProviderDoctorActionPayload,
  CreateProviderDoctorSuccessfulActionPayload,
  UpdateProviderDoctorActionPayload,
  UpdateProviderDoctorSuccessfulActionPayload,
  DeleteProviderDoctorActionPayload,
  DeleteProviderDoctorSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/provider-doctor-data-store';

/* action types */
export enum ActionTypes {
  GetProviderDoctors = '[PROVIDERDOCTOR] GetProviderDoctors',
  GetProviderDoctorsSuccessful = '[PROVIDERDOCTOR] GetProviderDoctorsSuccessful',
  GetProviderDoctorsFailure = '[PROVIDERDOCTOR] GetProviderDoctorsFailure',
  GetProviderDoctorById = '[PROVIDERDOCTOR] GetProviderDoctorById',
  GetProviderDoctorByIdSuccessful = '[PROVIDERDOCTOR] GetProviderDoctorByIdSuccessful',
  GetProviderDoctorByIdFailure = '[PROVIDERDOCTOR] GetProviderDoctorByIdFailure',
  CreateProviderDoctor = '[PROVIDERDOCTOR] CreateProviderDoctor',
  CreateProviderDoctorSuccessful = '[PROVIDERDOCTOR] CreateProviderDoctorSuccessful',
  CreateProviderDoctorFailure = '[PROVIDERDOCTOR] CreateProviderDoctorFailure',
  UpdateProviderDoctor = '[PROVIDERDOCTOR] UpdateProviderDoctor',
  UpdateProviderDoctorSuccessful = '[PROVIDERDOCTOR] UpdateProviderDoctorSuccessful',
  UpdateProviderDoctorFailure = '[PROVIDERDOCTOR] UpdateProviderDoctorFailure',
  DeleteProviderDoctor = '[PROVIDERDOCTOR] DeleteProviderDoctor',
  DeleteProviderDoctorSuccessful = '[PROVIDERDOCTOR] DeleteProviderDoctorSuccessful',
  DeleteProviderDoctorFailure = '[PROVIDERDOCTOR] DeleteProviderDoctorFailure',
  ResetState = '[PROVIDERDOCTOR] ResetState',
}

/* actions */

/* This event gets the all ProviderDoctors. */
export const GetProviderDoctors = createAction(ActionTypes.GetProviderDoctors);

/* This event is fired after getting all the ProviderDoctors successfully. */
export const GetProviderDoctorsSuccessful = createAction(
  ActionTypes.GetProviderDoctorsSuccessful,
  props<{ payload: GetProviderDoctorsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the ProviderDoctors. */
export const GetProviderDoctorsFailure = createAction(
  ActionTypes.GetProviderDoctorsFailure,
);

/* This event gets the ProviderDoctor by ProviderDoctor id. */
export const GetProviderDoctorById = createAction(
  ActionTypes.GetProviderDoctorById,
  props<{ payload: GetProviderDoctorByIdActionPayload }>(),
);

/* This event is fired after getting all the ProviderDoctor by ProviderDoctor id successfully. */
export const GetProviderDoctorByIdSuccessful = createAction(
  ActionTypes.GetProviderDoctorByIdSuccessful,
  props<{ payload: GetProviderDoctorByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the ProviderDoctor by ProviderDoctor id successfully. */
export const GetProviderDoctorByIdFailure = createAction(
  ActionTypes.GetProviderDoctorByIdFailure,
);

/* This event creates a ProviderDoctor. */
export const CreateProviderDoctor = createAction(
  ActionTypes.CreateProviderDoctor,
  props<{ payload: CreateProviderDoctorActionPayload }>(),
);

/* This event is fired after creating a ProviderDoctor successfully. */
export const CreateProviderDoctorSuccessful = createAction(
  ActionTypes.CreateProviderDoctorSuccessful,
  props<{ payload: CreateProviderDoctorSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a ProviderDoctor successfully. */
export const CreateProviderDoctorFailure = createAction(
  ActionTypes.CreateProviderDoctorFailure,
);

/* This event updates a ProviderDoctor. */
export const UpdateProviderDoctor = createAction(
  ActionTypes.UpdateProviderDoctor,
  props<{ payload: UpdateProviderDoctorActionPayload }>(),
);

/* This event is fired after updating a ProviderDoctor successfully. */
export const UpdateProviderDoctorSuccessful = createAction(
  ActionTypes.UpdateProviderDoctorSuccessful,
  props<{ payload: UpdateProviderDoctorSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a ProviderDoctor successfully. */
export const UpdateProviderDoctorFailure = createAction(
  ActionTypes.UpdateProviderDoctorFailure,
);

/* This event deletes a ProviderDoctor. */
export const DeleteProviderDoctor = createAction(
  ActionTypes.DeleteProviderDoctor,
  props<{ payload: DeleteProviderDoctorActionPayload }>(),
);

/* This event is fired after deleting a ProviderDoctor successfully. */
export const DeleteProviderDoctorSuccessful = createAction(
  ActionTypes.DeleteProviderDoctorSuccessful,
  props<{ payload: DeleteProviderDoctorSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a ProviderDoctor successfully. */
export const DeleteProviderDoctorFailure = createAction(
  ActionTypes.DeleteProviderDoctorFailure,
);

/* This event resets the ProviderDoctor state. */
export const ResetState = createAction(ActionTypes.ResetState);
